import UserRoleEnum from '@constants/enums/user/role';

const InvestorRoleEnum = Object.freeze({
    OWNER: UserRoleEnum.OWNER,
    USER: UserRoleEnum.USER,
    ACCOUNTANT: UserRoleEnum.ACCOUNTANT
});

export default InvestorRoleEnum;
